import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSlider } from '../../api/apiSliders';
import toast from 'react-hot-toast';
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export const useUpdateSlider = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateSliderMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateSlider(id, data),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['sliders'] });
            queryClient.invalidateQueries({ queryKey: ['slider'] });
            toast.success(data.message || 'Slider updated successfully');
            navigate('/sliders');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || 'Failed to update slider');
        },
    });

    return {
        updateSliderMutate,
        isPending,
    };
};